import { render } from "./EmployeeUpdate.vue?vue&type=template&id=5e7576ee&scoped=true"
import script from "./EmployeeUpdate.vue?vue&type=script&lang=ts"
export * from "./EmployeeUpdate.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-5e7576ee"

export default script